/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
import dayjs from 'dayjs';
import {compressFile} from '../../common/utils/compression';
import {
  DEFAULT_NATIONALITY,
  DEFAULT_RIP_AGENCE,
} from '../../data/constants/Assurance/AssuranceRapatriement/souscription';
import {
  BeneficiaireRapatriement,
  DevisRapatriementParam,
} from '../../data/types/interface/Assurance/AssuranceRapatriement/devis';
import {IRenouvellementRapatriement} from '../../data/types/interface/Assurance/AssuranceRapatriement/souscription';
import {
  ISaveDevis,
  souscriptionAssureBodyDTO,
} from '../applicatif/rapatriement';
import api, {postFormData} from '../technique/api';

interface SouscriptionDataDTO {
  montant: string;
  assure: Array<souscriptionAssureBodyDTO>;
  quoteCode: string;
}

export const RapatriementBDL = () => ({
  postDevis: async (data: DevisRapatriementParam[]): Promise<any> =>
    await api.post('repatrius/simulation', {beneficiaires: data}),

  redoDevis: async (
    data: DevisRapatriementParam[],
    dateEffet: Date,
  ): Promise<any> => {
    const formattedDate = dayjs(dateEffet).startOf('day').format('YYYY-MM-DD');
    return await api.post('repatrius/devis/create', {
      beneficiaires: data,
      dateEffect: formattedDate,
    });
  },

  saveDevis: async (data: ISaveDevis): Promise<any> => {
    return await api.post('repatrius/devis/save', {
      // agence: `${data.agence}`,
      dateEffect: dayjs(data.dateEffect).startOf('day').format('YYYY-MM-DD'),
      beneficiaires: data.beneficiaires.map(b => {
        const {
          newImage,
          lastCaptureFile,
          dateNaissance,
          id,
          isEditable,
          isNew,
          ...rest
        } = b;
        return {
          ...rest,
          dateNaissance: dayjs(b.dateNaissance)
            .startOf('day')
            .format('YYYY-MM-DD'),
        };
      }),
    });
  },

  // DELETE Devis
  removeDevis: async (id: string): Promise<any> =>
    await api.remove(`repatrius/devis/delete?id=${id}`),

  souscrireContrat: async (data: ISaveDevis): Promise<any> => {
    const dataFormated = {
      agence: DEFAULT_RIP_AGENCE,
      dateEffect: dayjs(data.dateEffect).startOf('day').format('YYYY-MM-DD'),
      beneficiaires: data.beneficiaires.map(b => {
        const {
          newImage,
          lastCaptureFile,
          dateNaissance,
          id,
          isEditable,
          isNew,
          ...rest
        } = b;
        return {
          ...rest,
          dateNaissance: dayjs(b.dateNaissance)
            .startOf('day')
            .format('YYYY-MM-DD'),
        };
      }),
    };

    const res: any = await api.post('repatrius/souscription', dataFormated);
    return res;
  },

  // GET list devis
  listDevis: async (): Promise<any> => await api.get('repatrius/devis/list'),

  // GET detail contrat
  detailContrat: async (numPolice: string): Promise<any> => {
    return await api.get(`repatrius/contrat?policyNumber=${numPolice}`);
  },

  getContratBySimulationId: async (
    simulationId: string,
    url: string = 'repatrius/contrat',
  ): Promise<any> => await api.get(`${url}?simulationId=${simulationId}`),

  getContratBypolicyNumber: async (
    policyNumber: string,
    url: string = 'repatrius/contrat',
  ): Promise<any> => await api.get(`${url}?policyNumber=${policyNumber}`),

  getStatusPayment: async (url: string = 'common/api-control'): Promise<any> =>
    await api.get(url),

  uploadCarteIdentitePhoto: async (file: File) => {
    const compressedFile = await compressFile(file);
    const formData = new FormData();
    formData.append('file', compressedFile);
    return postFormData(`repatrius/files/upload`, formData);
  },

  renewContrat: async (data: IRenouvellementRapatriement) => {
    return await api.post(`repatrius/renouvelement`, data);
  },

  getTemporaryAttestationToken: async (
    policyNumber: string,
    benef: BeneficiaireRapatriement,
    dateEffet: string,
    dateFin: string,
  ) => {
    const dateFormat = 'YYYYMMDD';
    const param = {
      nom: benef.nom || '',
      prenom: benef.prenom || '',
      nationalite: DEFAULT_NATIONALITY,
      dateNaissance: benef.dateNaissance
        ? dayjs(benef.dateNaissance, 'YYYY-MM-DD')
            .startOf('day')
            .format(dateFormat)
        : '',
      numeroPasseportORresidencePermit: benef.numCI,
      paysResidence: benef.paysResidence,
      type: 'attestation',

      policyEffectiveDate: dayjs(dateEffet, 'DD/MM/YYYY').format(dateFormat),
      policyEndDate: dayjs(dateFin, 'DD/MM/YYYY').format(dateFormat),
      beneficiaire: '',
    };

    const query = new URLSearchParams({
      policyNumber,
      contratType: 'repatrius',
      ...param,
    }).toString();
    console.log(query);

    return await api.get(`common/pdf-generator/link?${query}`);
  },

  getTemporaryFraisFuneraireRapatriementToken: async (
    policyNumber: string,
    benef: BeneficiaireRapatriement,
  ) => {
    const param = {
      nom: benef.nom || '',
      prenom: benef.prenom || '',
      nationalite: DEFAULT_NATIONALITY,
      dateNaissance: benef.dateNaissance
        ? dayjs(benef.dateNaissance, 'YYYY-MM-DD')
            .startOf('day')
            .format('YYYYMMDD')
        : '',
      numeroPasseportORresidencePermit: benef.numCI,
      paysResidence: benef.paysResidence,
      beneficiaire: '',
    };

    const query = new URLSearchParams({
      policyNumber,
      contratType: 'repatrius',
      ...param,
    }).toString();

    return await api.get(`common/pdf-generator/link?${query}`);
  },

  createContrat: async (simulationId: string) => {
    return await api.post(`repatrius/contrat`, {simulationId});
  },
});
